<template>
  <div :style="theStyle">
    <span  v-if="showPage == undefined" class="subheading">
        <span v-if="!pageLoadingError">
          <br /><br />Loading {{ this.$route.params.aid }}'s store <br />
          This can take a bit...<br />
          <v-progress-linear indeterminate></v-progress-linear>
          <br />
          {{ this.loadingStatus }}
        </span>
        <span v-else><br /><br />{{ pageLoadingError }}</span>
    </span>
    <span v-else-if="showPage === false" class="title ma-4 center">
        <br /><br />
        <img src="../../../static/images/smartkidsmarket-logo.svg" style="height:100px"/>
        <div class="error--text">
          SmartKidsMarket Error
        </div>
        <br />
        <div>We do not know the seller you selected. Double-check the URL or contact them.</div>
    </span>
    <span v-else >
        <BackToDashboard></BackToDashboard>
        <TopBar />

        <v-content style="">

            <v-layout column fill-height justify-space-between >
              <router-view></router-view>
            </v-layout>

        </v-content>
        <Footer></Footer>
    </span>
  </div>
</template>

<script>
import config from '../../config.js'

import TopBar from './TopBar.vue'
import Footer from '../common/Footer.vue'
import {mapState} from 'vuex'
// import themes from '../../themes.js'
import BackToDashboard from './BackToDashboard'

export default {
  name: 'ArtistPage',
  components: {
    TopBar,
    Footer,
    BackToDashboard
  },
  computed: {
    ...mapState({
      // theme: state => state.shopping.public_settings.theme
    })
  },
  data () {
    return {
      showPage: undefined,
      uid: undefined,
      pageLoadingError: null,
      theStyle: '',
      loadingStatus: ''
    }
  },
  watch: {
    // theme: function (newVal) {
    //   // Change the theme in the state also!
    //   if (!newVal) {
    //     newVal = 0
    //   }
    //   this.$store.dispatch('themeInfo/setTheme', newVal).then(() => {
    //     this.$vuetify.theme = themes.getTheme(newVal)
    //   })
    // }
  },
  mounted: async function () {
    // Check for the mapping from AID --> UID
    this.pageLoadingError = null

    // Load the theme from a cookie if present.
    this.$store.dispatch('themeInfo/loadBuyerThemeFromCookie', this.$route.params.aid )

    try {
      var getActiveUIDfromAID = config.getFunctions().httpsCallable('getActiveUIDfromAID')
      const data = await getActiveUIDfromAID({'aid': this.$route.params.aid})

      const uid = data.data
      if (uid != null && uid != undefined) {

        this.uid = uid
        this.loadingStatus = "Almost done..."

        // Now load the public settings
        await this.$store.dispatch('shopping/loadUid', {uid: uid, aid: this.$route.params.aid })
        this.loadingStatus = "Really close now..."

        // // If we don't have a theme, use 0!
        // if (!this.theme) {
        //   await this.$store.dispatch('themeInfo/setTheme', 0)
        //   this.$vuetify.theme = themes.getTheme(0)
        // }
        this.loadingStatus = ""

        console.log("Got UID: setting showPage is true")
        this.showPage = true

      } else {
        console.log("showPage is false")
        this.showPage = false
      }



    } catch(err) {
      this.loadingStatus = ""
      if (err.code === 'unavailable') {
        this.pageLoadingError = 'There was an error loading the page because you are offline'
      } else {
        this.pageLoadingError = 'There was an error loading the page: ' + err.message
      }
    }
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>
